var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cstm-status-badge",staticStyle:{"width":"calc(100% + 8px)","height":"34px","background":"rgba(var(--vs-primary), 1)","color":"#fff"}},[(_vm.params.data.final_marks)?_c('b',[_vm._v(_vm._s(Number(_vm.params.data.final_marks)))]):_c('b',[_vm._v(" N/A ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }